export default [
  {
    title: 'SNEAKERS',
    description: 'View All',
    backgroundImage: 'https://images4.imagebam.com/c6/67/bc/MEC4V69_o.png',
  },
  {
    title: 'APPAREL',
    description: 'View All',
    backgroundImage: 'https://images4.imagebam.com/53/32/33/MEC6VIU_o.PNG',
  },
  {
    title: 'LUXURY',
    description: 'View All',
    backgroundImage: 'https://images4.imagebam.com/81/23/ac/MEC6VJI_o.PNG',
  },
  {
    title: 'SLIDES',
    description: 'View All',
    backgroundImage: 'https://images4.imagebam.com/1a/14/6b/MEC6VK1_o.PNG',
  },
];
